module.exports = __webpack_public_path__ + "static/media/covid19_tracker.f821e36c.jpg";